import { render, staticRenderFns } from "./ExtraClassDetail.vue?vue&type=template&id=282bae33&scoped=true"
import script from "./ExtraClassDetail.vue?vue&type=script&lang=js"
export * from "./ExtraClassDetail.vue?vue&type=script&lang=js"
import style0 from "./ExtraClassDetail.vue?vue&type=style&index=0&id=282bae33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282bae33",
  null
  
)

export default component.exports